import {
  type NodeIconOptions,
  type NodeTypeIcon,
  nodeIconDefaultOptions,
} from '../NodeTypeIcon';
import { createSquareNodeTypeIcon, wrapNodeIconInSvgTag } from '../common';
import { drawSquareBackground } from '../drawIconBackground';

const ICON_SIZE = 40;

function createAwsInstanceIcon(options: NodeIconOptions = {}): string {
  const opts = { ...nodeIconDefaultOptions, ...options };

  const icon = `
    ${drawSquareBackground(ICON_SIZE, opts.style)}
    <path d="M29.5455 7.90911H30.1818C31.236 7.90911 32.0909 8.76402 32.0909 9.8182V10.4546H35.2727V29.5455H32.0909V30.1818C32.0909 31.2375 31.2352 32.0909 30.1818 32.0909H29.5455V35.2728H10.4545V32.0909H9.81818C8.76336 32.0909 7.90909 31.2367 7.90909 30.1818V29.5455H4.72727V10.4546H7.90909V9.8182C7.90909 8.76485 8.76254 7.90911 9.81818 7.90911H10.4545V4.72729H29.5455V7.90911Z" fill="white"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M10.4545 29.5455H29.5455V10.4545H10.4545V29.5455ZM34 13V11.7273H30.8182V9.81818C30.8182 9.46691 30.5331 9.18182 30.1818 9.18182H28.2727V6H27V9.18182H24.4545V6H23.1818V9.18182H20.6364V6H19.3636V9.18182H16.8182V6H15.5455V9.18182H13V6H11.7273V9.18182H9.81818C9.46627 9.18182 9.18182 9.46691 9.18182 9.81818V11.7273H6V13H9.18182V15.5455H6V16.8182H9.18182V19.3636H6V20.6364H9.18182V23.1818H6V24.4545H9.18182V27H6V28.2727H9.18182V30.1818C9.18182 30.5337 9.46627 30.8182 9.81818 30.8182H11.7273V34H13V30.8182H15.5455V34H16.8182V30.8182H19.3636V34H20.6364V30.8182H23.1818V34H24.4545V30.8182H27V34H28.2727V30.8182H30.1818C30.5331 30.8182 30.8182 30.5337 30.8182 30.1818V28.2727H34V27H30.8182V24.4545H34V23.1818H30.8182V20.6364H34V19.3636H30.8182V16.8182H34V15.5455H30.8182V13H34Z" fill="#ED7100"/>
  `;

  return wrapNodeIconInSvgTag(icon, ICON_SIZE, ICON_SIZE, 'topLeft', opts);
}

export const awsInstanceIcon: NodeTypeIcon = createSquareNodeTypeIcon(
  ICON_SIZE,
  createAwsInstanceIcon,
);
